import { apiGet, apiPost } from '../api-client.ts';

export interface RangeAndamentoGruppo {
  codiceGruppo: string;
  territori: Array<{ codice: string; nome: string }>;
  periodoInizio: string;
  periodoFine: string;
  periodi: string[];
  nPeriodi: number;
  periodiDisponibili: string[];
  periodoMinDisponibile: string;
  periodoMaxDisponibile: string;
}

export interface PuntoAndamentoGruppo {
  periodo: string;
  count: number;
}

export interface SeriePerTerritorioGruppo {
  codice: string;
  nome: string;
  color: string;
  punti: PuntoAndamentoGruppo[];
}

export interface SerieAndamentoGruppo extends RangeAndamentoGruppo {
  serieTotale: PuntoAndamentoGruppo[];
  seriePerTerritorio: SeriePerTerritorioGruppo[];
  totaleLatest: number;
  latestPeriodo: string;
  maxCount: number;
  ultimoCalcolo: string | null;
  territoriSaltati: string[];
  fromCache: boolean;
}

export const gruppoApi = {
  range: () => apiGet<{ range: RangeAndamentoGruppo }>('gruppo-statistiche/range'),
  serie: (periodoInizio?: string, periodoFine?: string) => {
    const qs = new URLSearchParams();
    if (periodoInizio) qs.set('periodoInizio', periodoInizio);
    if (periodoFine) qs.set('periodoFine', periodoFine);
    const suffix = qs.toString() ? `?${qs}` : '';
    return apiGet<SerieAndamentoGruppo>(`gruppo-statistiche/serie${suffix}`);
  },
  refresh: (periodoInizio?: string, periodoFine?: string) =>
    apiPost<SerieAndamentoGruppo>('gruppo-statistiche/refresh', {
      ...(periodoInizio ? { periodoInizio } : {}),
      ...(periodoFine ? { periodoFine } : {}),
    }),
};
